module.exports = __webpack_public_path__ + "h5/img/open.0a5d78b7.gif";